import React from 'react';

const Card = ({children, background}) => {
    const bg = background ?? 'bg-white';

    return <div className={`p-5 ${bg} rounded-xl w-full shadow-lg border`}>
        {children}
    </div>
}

export default Card;